import { useSelector, useDispatch } from 'react-redux';
import selectors from 'store/selectors';
import CustomDialog from 'components/CustomDialog/customDialog';
import { setDialog } from 'store/actions/dialogActions';
import { ContentCnt } from './Reminder.style';
import CustomDialogHeader from 'components/CustomDialog/DialogHeader/dialogHeader.cmp';
import DIALOGS from 'utils/dialogIds';
import { Box, Button, Typography } from '@mui/material';
import xeniaApi from 'api/index';
import ReminderIcon from 'components/Icons/reminderIcon';

const ReminderDialog = () => {
  const dispatch = useDispatch();
  const dialogState = useSelector(selectors.getDialogState);
  const { open, data = {} } =
    dialogState?.[DIALOGS?.REMINDER_ANNOUNCEMENT_DIALOG] || {};
  const { announcement, getAnnouncement } = data;

  const handleClose = () => {
    dispatch(
      setDialog({
        open: false,
        dialogId: DIALOGS?.REMINDER_ANNOUNCEMENT_DIALOG,
      }),
    );
  };

  const handleReminder = async () => {
    try {
      // Call API to delete the announcement
      await xeniaApi.sendReminder(announcement.id);
      await getAnnouncement();
      // Close the dialog
      handleClose();
    } catch (error) {
      console.error('Error sending reminder:', error);
      // Optionally show an error message to the user
    }
  };

  if (!announcement) return null;

  return (
    <CustomDialog
      header={
        <CustomDialogHeader
          other={{ sx: { alignItems: 'start' } }}
          onClose={handleClose}
        >
          <Box sx={{ textAlign: 'center' }}>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: '#EBEAFF',
                width: 90,
                height: 90,
                borderRadius: '50%',
                margin: 'auto',
              }}
            >
              <ReminderIcon
                sx={{
                  fontSize: 40,
                  '& path': {
                    fill: 'none',
                    stroke: '#6868FE',
                  },
                }}
              />
            </Box>
            <Typography fontSize={22} fontWeight={800} sx={{ mt: 2 }}>
              Send Reminder?
            </Typography>
          </Box>
        </CustomDialogHeader>
      }
      actionButtonCntProps={{
        primaryBtnProps: {
          onClick: handleReminder,
        },
        secondaryBtnProps: { onClick: handleClose },
      }}
      primaryBtnText="Send Reminder"
      dialogProps={{
        open: open,
        maxWidth: true,
        onClose: handleClose,
        sx: {
          '& .MuiDialog-paper': {
            maxWidth: '600px',
          },
        },
      }}
    >
      <ContentCnt>
        <Box sx={{ p: 3, textAlign: 'center' }}>
          {announcement.requireAcknowledgement ? (
            <>
              <Typography variant="body1">
                Some recipients haven't acknowledged this announcement.
              </Typography>

              <Typography variant="body1" sx={{ mb: 3 }}>
                Sending a reminder will notify them again.
              </Typography>

              <Typography sx={{ mb: 4, fontSize: '16px' }}>
                Reminders will only be sent to recipients who haven't
                acknowledged.
              </Typography>
            </>
          ) : (
            <>
              <Typography variant="body1" sx={{ mb: 3 }}>
                Some recipients haven't viewed this announcement yet. Sending a
                reminder will notify them to open and read it.
              </Typography>

              <Typography sx={{ mb: 4, fontSize: '16px' }}>
                Reminders will only be sent to recipients who haven't viewed the
                announcement.
              </Typography>
            </>
          )}
        </Box>
      </ContentCnt>
    </CustomDialog>
  );
};

export default ReminderDialog;
